import { Typography } from '@mui/material'
import React from 'react'

export default function Education1() {
  return (
   <div className='objective'>
       <Typography style={{fontFamily:"Cursive",fontSize:"25px", padding:"80px"}}>
       Subject: Intern Acceptance <br/><br/>

          Dear manager,
          <br/><br/>
          Thank you for offering me the opportunity to work in your company a Intern in software developing. I sincerely appreciate your time and consideration.

          I'm happy to accept this  position . As we move forward, I'd like to clarify company's remote work policy. Please contact me at 9843874579 or aadarshasoti01@gmail.com to establish the next steps.
          <br/><br/>
          Thank you again for this opportunity. I'm excited to work with the your team soon.
          <br/><br/>
          Sincerely,<br/>
          Adarsha Soti 
          <br/>
          <br/>
          <a href='/'>
          <button className='btn primary-btn' >
              {""}
            back to home page {" "}
          </button>
          </a>
 </Typography>
   </div>
  )
}
